export const ConfigDataForModuleConfiguration = [
  {
    id: "name",
    name: "Module",
    isShow: true,
    width: "400px",
    filter: false,
  },
  {
    id: "status",
    name: "Status",
    isShow: true,
    width: "160px",
    filter: false,
  },
  {
    id: "button",
    name: "Action",
    type: "dropdown",
    isShow: true,
    width: "117px",
    action: ["Update Status"],
    permission: {
      ["Update Status"]: {
        id: "Update Status",
        permission: "gamifications.view_campaign_operator_list",
      },
    },
  },
];



export const ConfigDataForRewardProvider = [
  {
    id: "name",
    name: "Provider Name",
    isShow: true,
    width: "160px",
    filter: false,
  },
  {
    id: "image",
    name: "Provider Image",
    type: "image",
    isShow: true,
    width: "160px",
    filter: false,
    imageSize: { width: "150px", height: "150px" },

  },
  {
    id: "button",
    name: "Action",
    type: "dropdown",
    isShow: true,
    width: "117px",
    action: ["Delete"],
    permission: {
      ["Delete"]: {
        id: "Delete",
        permission: "gamifications.view_campaign_operator_list",
      },
    },
  },
];



export const ConfigDataForCampaignCategory = [
  {
    id: "name",
    name: "Category Name",
    width: "600px",
    isShow: true,
    filter: false,
  },
  {
    id: "button",
    name: "Action",
    type: "dropdown",
    isShow: true,
    width: "117px",
    action: ["Edit","Delete"],
    permission: {
      ["Edit"]: {
        id: "Edit",
        permission: "gamifications.view_campaign_operator_list",
      },
      ["Delete"]: {
        id: "Delete",
        permission: "gamifications.view_campaign_operator_list",
      },
    },
  },
];



export const ConfigDataForEarningLimitPeriod = [
  {
    id: "label",
    name: "Period",
    isShow: true,
    filter: false,
  },
  {
    id: "status",
    name: "Status",
    isShow: true,
    filter: false,
  },
  {
    id: "button",
    name: "Action",
    type: "dropdown",
    isShow: true,
    width: "117px",
    action: ["Update Status"],
    permission: {
      ["Update Status"]: {
        id: "Update Status",
        permission: "gamifications.view_campaign_operator_list",
      },
    },
  },
];



export const ConfigDataForGlobalConfig = [
  {
    id: "max_coupons",
    name: "Max Claim Coupon",
    width: "300px",
    isShow: true,
    filter: false,
  },
  {
    id: "reset_period_month",
    name: "Points Reset Period (Month)",
    width: "300px",
    isShow: true,
    filter: false,
  },
  {
    id: "button",
    name: "Action",
    type: "dropdown",
    isShow: true,
    width: "117px",
    action: ["Edit"],
    permission: {
      ["Edit"]: {
        id: "Edit",
        permission: "gamifications.view_campaign_operator_list",
      },
    },
  },
];
